import React from 'react';
import moment from 'moment';

import { TableComponent, connect } from './tableComponent';
import config from '../config';

class Component extends TableComponent {
  initialState = {
    from: moment().subtract(1, 'month'),
    to: moment().add(1, 'day'),
    type: 'all',
    include_slaves: true
  };

  getInitialState = (initialState) => {
    initialState.from = moment().subtract(1, 'month');
    initialState.include_slaves = this.props.user.role_id > 0;
    return initialState;
  };

  makeColumns = () => {
    let columns = [
      {
        Header: 'Id',
        id: 'landing_id',
        accessor: (d) => parseInt(d.landing_id),
        minWidth: 30
      },
      {
        Header: 'Offer',
        accessor: 'offer',
        minWidth: 50,
        Cell: (props) => this.offers[props.value]
      },
      {
        Header: 'Name',
        accessor: 'name',
        minWidth: 70
      },
      {
        Header: 'Link',
        id: 'link',
        accessor: (d) => {
          var link = d.link;
          if (link.indexOf('?') == -1) link += '?';
          if (link[link.length - 1] != '?') link += '&';
          link += 'wid=' + this.props.user.aid;
          return link;
        },
        // accessor: "link",
        minWidth: 190,
        Cell: (props) => (
          <a target='_blank' href={props.value}>
            {props.value}
          </a>
        )
      },
      {
        Header: 'Unique visits',
        id: 'unique_visits',
        accessor: (d) => parseInt(d.unique_visits),
        minWidth: 50
      },
      {
        Header: 'Sales',
        id: 'sales',
        accessor: (d) => parseInt(d.sales),
        minWidth: 30
      },
      {
        Header: 'Rate, %',
        id: 'conversion',
        accessor: (d) => ((parseInt(d.sales) || 0) / (parseInt(d.unique_visits) || 1)) * 100,
        minWidth: 40,
        Cell: (props) => props.value.toFixed(1)
      }
    ];
    if (this.props.user.role_id >= 4) {
      columns.splice(3, 0, {
        Header: 'Visits',
        id: 'visits',
        accessor: (d) => parseInt(d.visits),
        minWidth: 50
      });
    }
    return columns;
  };

  apiPath = 'links/allStats';

  tableParams = {
    manual: false,
    sorted: [
      {
        id: 'landing_id',
        desc: true
      }
    ],
    showAll: true
  };
  fetchParams = (state) => {
    return {
      include_slaves: this.props.state.include_slaves
    };
  };

  typeOptions = [
    { name: 'All', value: 'all' },
    { name: 'HLink', value: 'chatsales' },
    { name: 'A', value: 'andy' },
    { name: 'CPS', value: 'andy1' },
    { name: 'A3', value: 'andy30' },
    { name: 'A6', value: 'andy60' },
    { name: 'Wellhello', value: 'wellhello' },
    { name: 'Spice', value: 'spice' },
    { name: 'SandraCams', value: 'sandra_sales' },
    { name: 'EasySx', value: 'easysex' },
    { name: 'Cupid', value: 'cupid' },
    // { name: 'Loc', value: 'loc' },
    { name: 'KLink', value: 'chrissales' },
    { name: 'Livecam', value: 'imlive' },
    { name: 'CeVIP', value: 'cevip' },
    { name: 'Iframecash', value: 'sexplaycam' },
    { name: 'Higher', value: 'hgh2' },
    { name: 'H1', value: 'hg1' },
    { name: 'HBay', value: 'hookupbay' },
    { name: 'DGold', value: 'dgold' },
    { name: 'PunkBank', value: 'punk' },
    { name: 'PunkBank1', value: 'punk1' },
    { name: 'SLink', value: 'sms' }
  ];

  offers = {
    easysex: 'EasySx',
    chatsales: 'HLink',
    andy: 'A',
    andy1: 'A1',
    andy30: 'A3',
    andy60: 'A6',
    wellhello: 'Wellhello',
    chrissales: 'KLink',
    cevip: 'CeVIP',
    cupid: 'Cupid',
    loc: 'Loc',
    sexplaycam: 'Iframecash',
    imlive: 'Livecam',
    spice: 'Spice',
    sandra_sales: 'SandraCams',
    hgh2: 'Higher',
    hg1: 'H1',
    hookupbay: 'HBay',
    dgold: 'DGold',
    punk: 'PunkBank',
    punk1: 'PunkBank1',
    sms: 'SLink'
  };
  offersKeys = Object.keys(this.offers) || [];

  render() {
    let offers = this.offersKeys.filter((offer) => this.props.user[offer] == '1');
    return (
      <div class='co__all-links-stats'>
        {!this.props.state.initial && (
          <div class='row table-head-controls co__table-filters'>
            <div class='col-10'>
              {this.datepickerElement()}
              <div class='d-inline-block ml-2'>
                <label class='ui-switch ui-switch-md info m-t-xs table-head-switch'>
                  <input
                    type='checkbox'
                    name='include_slaves'
                    checked={this.props.state.include_slaves}
                    onChange={this.changeType}
                  />
                  <i></i>
                </label>
                {this.props.user.role_id > 0 && (
                  <span class='ml-1 switch-description'>Include affiliates</span>
                )}
              </div>
              <select
                class='form-control form-control-sm table-select mr-4 pull-right'
                onChange={this.changeType}
                name='type'
              >
                <option value='all'>All</option>
                {offers.map((offer) => (
                  <option key={offer} value={offer}>
                    {this.offers[offer]}
                  </option>
                ))}
              </select>
            </div>
            {this.props.user.role_id >= 4 && <div class='col-2'>{this.searchElement()}</div>}
          </div>
        )}
        <div class='row'>
          <div class='col-sm-12'>
            <div class='box mt-2 text-center'>{this.reactTable()}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(Component, 'links_allStats');
